import { Box } from 'ui/Layout';

import SVGScratch from './SVGScratch';
import SankeySVG from './SankeySVG';

type Props = {
  hasBorder?: boolean;
};

const ReadOnlySankeyChart: React.FC<Props> = ({ hasBorder = true }) => (
  <Box
    id="chart"
    overflow="hidden"
    position="relative"
    pointerEvents="none"
    {...(hasBorder ? { border: '1px solid', borderColor: 'gray.300' } : {})}
  >
    <SankeySVG />
    <SVGScratch />
  </Box>
);

export default ReadOnlySankeyChart;
